exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\r\n    /*min-height: 150px;*/\r\n}\r\n\r\n.grid-wrapper {\r\n  position: relative;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}\r\n\r\n.cd-wrp{\r\n    position: relative;\r\n    /*display: grid;*/\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -ms-grid-rows: 1fr min-content;\r\n        grid-template-rows: 1fr -webkit-min-content;\r\n        grid-template-rows: 1fr min-content;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 auto;\r\n            flex: 1 1 auto;\r\n    max-width: 100%;\r\n}\r\n\r\n.view-mode.cd-wrp{\r\n    -ms-grid-rows: min-content 1fr min-content;\r\n        grid-template-rows: -webkit-min-content 1fr -webkit-min-content;\r\n        grid-template-rows: min-content 1fr min-content;\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/simple-tab.component/simple-tab.component.css
// module id = ./src/app/buffer-graph/components/simple-tab.component/simple-tab.component.css
// module chunks = main